<div class="modal active">
    <div class="modal__container modal__container--md">
        <div class="fields">
            <h2>Airspace Vertex Import Options</h2>
            <div class="close" (click)="cancel()"><img src="/assets/img/close-white.svg" alt="" /></div>
              <div class="fields__container" style="flex-direction: column;justify-content: flex-start;">
                <div class="fields__block">
                    <div class="fields__block__section">
                        <div class="title">
                          <h4>Data Source</h4>
                          <span> </span>
                        </div>
                        <div class="dropdown-fields">
                          <div>
                            <label for="">File Data Source</label>
                            <select required [(ngModel)]="fileDataSource">
                              <option value="published">Published</option>
                              <option value="userDefined">User Defined</option>
                            </select>
                          </div>
                        </div>
                    </div>
                    <div class="fields__block__section">
                        <div class="title">
                            <h4>Vertex to Import</h4>
                            <span> </span>
                        </div>
                        <div class="table-fields">
                            <div class="filter">
                                <a (click)="selectAll()" style="cursor: pointer">Select All</a>
                                <a (click)="deselectAll()" style="cursor: pointer">Deselect All</a>
                            </div>
                            <div style="height: 240px; overflow-y:auto;">
                                <table class="special" style="display: block;width: 100%;">
                                    <thead>
                                        <tr>
                                            <th scope="col" style="width: 400px;">Select</th>
                                            <th scope="col" style="width: 400px;">Type</th>
                                            <th scope="col" style="width: 400px;">Code</th>
                                            <th scope="col" style="width: 400px;">Name</th>
                                        </tr>
                                    </thead>
                                    <tbody style=" overflow-y: auto; display: block; width: 100%;">
                                        <tr mdbTableCol *ngFor="let vertexTypeParent of vertexTypeMap | keyvalue; let iParent = index"
                                          [ngClass]="[vertexTypeRowExpanded[iParent] ? 'active' : '' ]">

                                            <div style="flex-direction: column">
                                              <label
                                                [ngClass]="[
                                                    vertexTypeRowExpanded[iParent] ? 'active' : '',
                                                    vertexTypeRowExpanded[iParent] ? 'colapsable' : 'colapsable'
                                                ]" for="" (click)="colapsableLabelVertexType(iParent)">{{vertexTypeParent.key}}

                                                <input type="checkbox" [checked]="checkIfAllSelected(vertexTypeParent.key)"
                                                (change)="changeSelectedParent(vertexTypeParent.key, $event)" style="top: 2px !important; position: relative; left: 5px;">

                                              </label>
                                            </div>
                                            <ng-container *ngIf="vertexTypeRowExpanded[iParent]">
                                              <tr *ngFor="let vertexTypeChild of vertexTypeParent.value; let iChild = index ">
                                                <td style="width: 400px;">
                                                    <input type="checkbox" [checked]="vertexTypeChild.selected" (change)="changeSelectedChild(vertexTypeParent.key, iChild)">
                                                </td>
                                                <td style="width: 400px;">{{vertexTypeChild.codeType}}</td>
                                                <td style="width: 400px;">{{vertexTypeChild.codeId}}</td>
                                                <td style="width: 400px;">{{vertexTypeChild.airspaceName}}</td>
                                              </tr>
                                            </ng-container>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="fields__btn">
                    <button (click)="proceedWithImport()" class="blue">Ok</button>

                    <button (click)="cancel();" class="blue" >Cancel</button>
                </div>
              </div>
        </div>
      </div>
  </div>
